export default __webpack_public_path__ + "static/media/001-painting-roller.ecf0d69f.svg";